"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetTransactionPwdRequest = void 0;
var ResetTransactionPwdRequest = /** @class */ (function () {
    function ResetTransactionPwdRequest() {
    }
    return ResetTransactionPwdRequest;
}());
exports.ResetTransactionPwdRequest = ResetTransactionPwdRequest;
;
//# sourceMappingURL=resetTransactionPwd.request.js.map